export default __webpack_public_path__ + "static/media/grid13.2f911a67.png";